var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#0DA9B9",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 12.6667C9.49533 12.6667 8 11.1713 8 9.33333C8 7.49533 9.49533 6 11.3333 6C13.1713 6 14.6667 7.49533 14.6667 9.33333H13.3333C13.3333 8.23067 12.436 7.33333 11.3333 7.33333C10.2307 7.33333 9.33333 8.23067 9.33333 9.33333C9.33333 10.436 10.2307 11.3333 11.3333 11.3333V12.6667Z",
    fill: "#007FA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.6667H12V10H14.6667V11.2193C15.0563 11.0809 15.3936 10.8253 15.6322 10.4877C15.8709 10.15 15.9994 9.74683 16 9.33333V8H17.3333V9.33333C17.3333 11.1713 15.838 12.6667 14 12.6667Z",
    fill: "#007FA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 18.6666H6V17.3333C6 14.9779 8.19333 13.3333 11.3333 13.3333C14.4733 13.3333 16.6667 14.9779 16.6667 17.3333V18.6666ZM7.33333 17.3333H15.3333C15.3333 15.7633 13.6887 14.6666 11.3333 14.6666C8.978 14.6666 7.33333 15.7633 7.33333 17.3333Z",
    fill: "#007FA1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadIcon);
export default __webpack_public_path__ + "static/media/load-icon.03732955edfadf849f70d80a0e7ea21a.svg";
export { ForwardRef as ReactComponent };